import { getRem, isMobileResolution, isTabletResolution } from "./utils/utils";

async function handleBurgerClick() {
  if (!isMobileResolution() && !isTabletResolution()) return;

  const headerBurger = document.querySelector<HTMLElement>(".header__burger");
  const headerMain = document.querySelector<HTMLElement>(".header__main");

  if (!headerBurger || !headerMain) return;

  const closeMenu = (): void => {
    headerBurger.classList.remove("header__burger--active");
    headerMain.classList.remove("header__main--active");
    document.body.classList.remove("lock");
  };

  headerBurger.addEventListener("click", () => {
    headerBurger.classList.toggle("header__burger--active");
    headerMain.classList.toggle("header__main--active");
    document.body.classList.toggle("lock");
  });

  headerMain.addEventListener("click", (event: MouseEvent) => {
    const target = event.target as HTMLElement;

    const link = target.closest<HTMLAnchorElement>("a");

    if (!link || !link.hash) return;

    closeMenu();
  });

  document.addEventListener("click", (event: MouseEvent) => {
    const targetNode = event.target as Node;

    const isBurgerClicked = headerBurger.contains(targetNode);
    const isMenuInnerClicked =
      headerMain.firstElementChild?.contains(targetNode);

    if (!isBurgerClicked && !isMenuInnerClicked) {
      closeMenu();
    }
  });
}

function isTouchMenu(): boolean {
  return isMobileResolution() || isTabletResolution();
}

function handleSubmenu() {
  const items = document.querySelectorAll<HTMLElement>(
    ".header__menu-list .menu-item-has-children",
  );

  const CLOSE_DELAY = 300;

  // потолок высоты раскрытого подменю (в rem-токенах дизайна)
  const MAX_HEIGHT_REM = 600;

  // 600rem в реальных px: rem тут масштабируется (html font-size: calc(100vw / 1920))
  const capPx = (): number => MAX_HEIGHT_REM * getRem();

  // текущий открытый пункт — чтобы при открытии нового закрыть предыдущий
  let openItem: { li: HTMLElement; close: () => void } | null = null;

  items.forEach((li) => {
    const submenu = li.querySelector<HTMLElement>(":scope > .sub-menu");

    if (!submenu) return;

    let closeTimer: ReturnType<typeof setTimeout> | undefined;

    const open = (): void => {
      clearTimeout(closeTimer);

      // закрываем ранее открытое подменю (аккордеон)
      if (openItem && openItem.li !== li) {
        openItem.close();
      }

      const touch = isTouchMenu();
      submenu.style.display = touch ? "flex" : "grid";
      // force reflow so the transition can pick up the new state
      void submenu.offsetHeight;
      li.classList.add("is-open");
      // мобила — на всю высоту; ПК — не выше потолка (длинные меню скроллятся)
      const cap = touch ? Infinity : capPx();
      const overflows = submenu.scrollHeight > cap;
      submenu.style.maxHeight = `${Math.min(submenu.scrollHeight, cap)}px`;

      if (overflows) {
        // скролл включаем после раскрытия, чтобы скроллбар не мигал в анимации
        const onOpenEnd = (event: TransitionEvent): void => {
          if (event.target !== submenu || event.propertyName !== "max-height") {
            return;
          }
          submenu.removeEventListener("transitionend", onOpenEnd);
          if (li.classList.contains("is-open")) {
            submenu.style.overflowY = "auto";
          }
        };
        submenu.addEventListener("transitionend", onOpenEnd);
      }
      openItem = { li, close };
    };

    const close = (): void => {
      li.classList.remove("is-open");
      if (openItem?.li === li) openItem = null;

      // на время схлопывания возвращаем клиппинг (overflow: hidden из CSS)
      submenu.style.overflowY = "";
      // схлопываем от текущей (на ПК — ограниченной потолком) высоты к нулю
      const cap = isTouchMenu() ? Infinity : capPx();
      submenu.style.maxHeight = `${Math.min(submenu.scrollHeight, cap)}px`;
      void submenu.offsetHeight;
      submenu.style.maxHeight = "0";

      const onEnd = (event: TransitionEvent): void => {
        if (event.target !== submenu) return;
        // ждём именно завершения схлопывания высоты, не opacity
        if (event.propertyName !== "max-height") return;

        submenu.removeEventListener("transitionend", onEnd);

        if (!li.classList.contains("is-open")) {
          submenu.style.display = "none";
          submenu.style.maxHeight = "";
        }
      };

      submenu.addEventListener("transitionend", onEnd);
    };

    const toggle = (): void => {
      if (li.classList.contains("is-open")) {
        close();
      } else {
        open();
      }
    };

    li.addEventListener("mouseenter", () => {
      if (isTouchMenu()) return;

      open();
    });

    li.addEventListener("mouseleave", () => {
      if (isTouchMenu()) return;

      clearTimeout(closeTimer);
      closeTimer = setTimeout(close, CLOSE_DELAY);
    });

    const link = li.querySelector<HTMLAnchorElement>(
      ":scope > .menu-item__link",
    );

    link?.addEventListener("click", (event: MouseEvent) => {
      if (!isTouchMenu()) return;

      event.preventDefault();
      toggle();
    });
  });
}

export function initHeader() {
  handleBurgerClick();
  handleSubmenu();
}
